import React from "react";
import { FormattedMessage } from "react-intl";
import {
  EcgReviewState,
  IFindings,
  ILead,
} from "../../../../models/ecg.interface";
import { getCheckedLeads } from "../../../../utils/ecgUtil";
import MetaCard from "../MetaCard/MetaCard";
import styles from "./MetaFindings.module.css";
import { useAuthContext } from "../../../../context/AuthContext";
import Role from "../../../../models/role";

type MetaFindingsProps = {
  findings?: IFindings[];
  compare?: boolean;
  showSuggestive?: boolean;
  ecgReviewState?: EcgReviewState;
};

const MetaFindings = ({
  findings,
  compare,
  showSuggestive,
  ecgReviewState,
}: MetaFindingsProps) => {
  const {
    state: { user },
  } = useAuthContext();
  const filteredFindings = findings?.filter((f) => f.value);
  const isInProcessIndication =
    ecgReviewState &&
    (ecgReviewState === EcgReviewState.MokedReviewInProcess ||
      ecgReviewState === EcgReviewState.ECRReviewInProcess) &&
    user &&
    user.role !== Role.Reviewer;

  const isShowFindingLeads = (finding: IFindings): boolean => {
    return getCheckedLeads(finding.leads!).length !== 0;
  };

  return (
    <MetaCard compare={compare}>
      <table className={`${styles.table} table font-md m-0`}>
        <thead>
          <tr>
            <th className="border-0 p-0 pb-1">
              <p className="mb-0 prim-color-dark font-weight-bold">
                <FormattedMessage
                  id="ECG_DETAILS.FINDINGS"
                  defaultMessage="Findings"
                />
              </p>
            </th>
            {showSuggestive && (
              <th className="border-0 p-0 pb-1">
                <p className="mb-0 prim-color-dark font-weight-bold">
                  <FormattedMessage
                    id="ECG_DETAILS.FINDINGS.SUGGESTIVE"
                    defaultMessage="Suggestive Of"
                  />
                </p>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {!filteredFindings?.length && isInProcessIndication && (
            <tr key={"inProgress"}>
              <td className="p-1">
                <p className="mt-2 mb-0">Findings are in process...</p>
              </td>
            </tr>
          )}
          {filteredFindings?.map((f, index) => (
            <tr key={`${index}_${f.key}`}>
              <td className="p-1">
                {f.displayName}
                {isShowFindingLeads(f) && (
                  <MetaFindingsLeads leads={getCheckedLeads(f.leads!)} />
                )}
              </td>
              {showSuggestive && <td className="p-1">{f.suggestiveOf}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </MetaCard>
  );
};

export default MetaFindings;

type MetaFindingsLeadsProps = { leads: ILead[] };
const MetaFindingsLeads = ({ leads }: MetaFindingsLeadsProps) => {
  return (
    <div>
      (Leads :
      {leads.map((lead: ILead) => (
        <div key={lead.code.toString()} className="d-inline-block">
          &nbsp;{lead.name}
        </div>
      ))}
      )
    </div>
  );
};
